import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconChevron.css';

const IconChevron = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg className={classes} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.39989 8.78136L11.6999 5.48136L12.6426 6.42403L8.39989 10.6667L4.15723 6.42403L5.09989 5.48136L8.39989 8.78136Z" fill="#101010" />
    </svg>

  );
};

IconChevron.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconChevron.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconChevron;
